import React, { useEffect, useState,useRef } from "react";
import "../style/page/Pharmacyissuelist.scss";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
    
    Pharmacylistissue,
  Pharmacylistissueid,
  sidebar,
} from "../redux/reducer/counterslice";
import { medicinetype, pharmacyissue } from "../../text/apidata";
import Swal from "sweetalert2";

function MedicineTypeForm(props) {
    const dispatch = useDispatch();
    const productstate = useSelector((state) => state.counter.Pharmacylistissue);
    const productid = useSelector((state) => state.counter.Pharmacylistissueid);
    const [pharmacyissuelistdata, setpharmacyissuelistdata] = useState({
        medicine_type: "",
        description: "",
      });
      const [alert, setalert] = useState(false);
      const [error, seterror] = useState(false);
      const handleSubmit = (event) => {
        event.preventDefault();
      };
    
    useEffect(() => {
        if (productstate == "pharmacyissuelistedit") {
          axios({
            method: "get",
            url: medicinetype + productid + "/",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token") + "",
            },
          })
            .then((res) => {
              console.log(res);
              setpharmacyissuelistdata({
                ...pharmacyissuelistdata,
                medicine_type: res.data.data.medicine_type,
                description:res.data.data.description
              });
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }, [productstate]);
    const Descriptionvalidation = (e) => {
        setalert(true);
    
        const { name, value } = e.target;
        setpharmacyissuelistdata({
          ...pharmacyissuelistdata,
          [name]: value,
        });
      };
    
      const newusercreat = (e) => {
        if (pharmacyissuelistdata.medicine_type != "" && pharmacyissuelistdata.description!="") {
          if (productstate == "pharmacyissuelistedit") {
            props.loaderchange("true");
    
            axios({
              method: "put",
              url: medicinetype + productid + "/",
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token") + "",
              },
              data: pharmacyissuelistdata,
            })
              .then((res) => {
                console.log(res);
                dispatch(Pharmacylistissue(""));
                setalert(false);
    
                setpharmacyissuelistdata({
                  ...pharmacyissuelistdata,
                  medicine_type: "",
                  description: "",
                });
                seterror(false);
                props.loaderchange("false");
                props.popupalert("true");
                props.popuptext("Pharmacy Issue List Updated Successfully");
                setTimeout(() => {
                  props.popupalert("false");
                }, 2000);
              })
              .catch((error) => {
                console.log(error);
                props.loaderchange("true");
                props.popupalert("true");
                props.popuptext(error.response.data.status.message);
                setTimeout(() => {
                  props.popupalert("false");
                }, 2000);
                props.loaderchange("false");
              });
          } else {
            props.loaderchange("true");
    
            axios({
              method: "post",
              url: medicinetype,
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token") + "",
              },
              data: pharmacyissuelistdata,
            })
              .then((res) => {
                console.log(res);
                dispatch(Pharmacylistissue(""));
                setalert(false);
    
                setpharmacyissuelistdata({
                  ...pharmacyissuelistdata,
                  medicine_type: res.data.data.medicine_type,
                  description:res.data.data.description
                });
                seterror(false);
                props.loaderchange("false");
                props.popupalert("true");
                props.popuptext("Pharmacy Issue List Created Successfully");
                setTimeout(() => {
                  props.popupalert("false");
                }, 2000);
              })
              .catch((error) => {
                console.log(error);
                props.loaderchange("false");
                props.popupalert("true");
                props.popuptext(error.response.data.status.message);
                setTimeout(() => {
                  props.popupalert("false");
                }, 2000);
              });
          }
        } else {
          seterror(true);
        }
      };
  return (
    <>
          <div className="maincontainer">
            <div className="parent-symptomsform">
              <div className="create-symptomsform card">
                <div class="modal-header">
                  <h5 class="modal-title">
                    {productstate == "pharmacyissuelistedit"
                      ? " Medicine Type Edit"
                      : " Medicine Type Create"}
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={(e) => {
                      if (alert) {
                        Swal.fire({
                          title: "Are you sure?",
                          text: "You won't be able to revert this!",
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Yes, revert it!",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            // Swal.fire(
                            //   "Deleted!",
                            //   "Given Info has been deleted.",
                            //   "success"
                            // );
                            dispatch(Pharmacylistissue(""));
                            setalert(false);

                            setpharmacyissuelistdata({
                              ...pharmacyissuelistdata,
                              medicine_type: "",
                            });
                          }
                        });
                      } else {
                        dispatch(Pharmacylistissue(""));
                        setalert(false);

                        setpharmacyissuelistdata({
                          ...pharmacyissuelistdata,
                          medicine_type: "",
                        });
                      }
                    }}
                  >
                    <i class="bi bi-x-lg"></i>
                  </button>
                </div>
                <div class="modal-body" style={{ padding: "0 !important" }}>
                  <form
                    style={{ padding: "0 1.5rem 1rem" }}
                    className="formspace"
                    onSubmit={handleSubmit}
                  >
                    <div className="row m-2">
                      <div className="col-md-6">
                        <label class="form-label">Medicine  Type</label>

                        <textarea
                          type="textarea"
                          class="form-control"
                          id="validationCustom01"
                          name="medicine_type"
                          value={pharmacyissuelistdata.medicine_type}
                          style={{ resize: "none" }}
                          onChange={(e) => Descriptionvalidation(e)}
                          onKeyDown={(e) => {
                            if (e.target.value.length === 0 && e.which === 32) {
                              e.preventDefault();
                            }
                          }}
                          rows="3"
                          required
                        ></textarea>
                        {error && pharmacyissuelistdata.medicine_type == "" && (
                          <p style={{ fontSize: "12px", color: "red" }}>
                            Report Type Required
                          </p>
                        )}
                      </div>
                      <div className="col-md-6">
                        <label class="form-label">Description</label>

                        <textarea
                          type="textarea"
                          class="form-control"
                          id="validationCustom01"
                          name="description"
                          value={pharmacyissuelistdata.description}
                          style={{ resize: "none" }}
                          onChange={(e) => Descriptionvalidation(e)}
                          onKeyDown={(e) => {
                            if (e.target.value.length === 0 && e.which === 32) {
                              e.preventDefault();
                            }
                          }}
                          rows="3"
                          required
                        ></textarea>
                        {error && pharmacyissuelistdata.description == "" && (
                          <p style={{ fontSize: "12px", color: "red" }}>
                            Report Type Required
                          </p>
                        )}
                      </div>
                    </div>

                    <div
                      class="form-row"
                      style={{
                        display: "flex",
                        flexFlow: "row wrap",
                        placeContent: "center space-between",
                        alignItems: "center",
                      }}
                    >
                      <div class=" col-md-12">
                        <button
                          type="submit"
                          class="btn btn-primary  create"
                          onClick={(e) => newusercreat(e)}
                          disabled={!alert ? true : false}

                        >
                          {productstate == "pharmacyissuelistedit"
                            ? "Update  Medicine Type"
                            : " Create  Medicine Type"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

    </>
  );
}

export default MedicineTypeForm;
